/**
 * UTF-16 Encoding.
 *
 *
 * @beta
 */
export const UTF_16 = 'utf-16'
